import { createContext } from "react";

const flightContent = createContext()

export default  flightContent